import { render } from "./ExpenseModalSectionFiles.vue?vue&type=template&id=40e55fb0"
import script from "./ExpenseModalSectionFiles.vue?vue&type=script&lang=js"
export * from "./ExpenseModalSectionFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__